<template>
  <BusinessCrud
    title="发票申请"
    :columns="columns"
    :search-fields="searchFields"
    :form-fields="formFields"
    :list-api="getInvoiceList"
    :save-api="saveInvoice"
    :delete-api="deleteInvoice"
    :export-api="exportInvoiceList"
    export-file-name="发票明细.xlsx"
    :allow-create="false"
    :allow-delete="false"
    :defaults="{ invoiceType: '普票', status: '待开票', amount: 0 }"
  />
</template>

<script>
import BusinessCrud from '@/components/BusinessCrud'
import { getInvoiceList, exportInvoiceList, saveInvoice, deleteInvoice } from '@/api'

export default {
  components: { BusinessCrud },
  data() {
    const statusOptions = [
      { label: '待开票', value: '待开票' },
      { label: '已开票', value: '已开票' },
      { label: '开票中', value: '开票中' },
      { label: '已驳回', value: '已驳回' },
      { label: '已取消', value: '已取消' },
      { label: '已作废', value: '已作废' }
    ]
    return {
      getInvoiceList,
      saveInvoice,
      deleteInvoice,
      exportInvoiceList,
      searchFields: [
        { key: 'orderNo', label: '订单编号' },
        { key: 'invoiceTitle', label: '发票抬头' },
        { key: 'status', label: '开票状态', type: 'select', options: statusOptions },
        { key: 'startDate', label: '申请开始日期', type: 'date' },
        { key: 'endDate', label: '申请结束日期', type: 'date' }
      ],
      columns: [
        { title: '订单编号', dataIndex: 'orderNo' },
        { title: '发票抬头', dataIndex: 'invoiceTitle' },
        { title: '税号', dataIndex: 'taxNo' },
        { title: '金额', dataIndex: 'amount' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } }
      ],
      formFields: [
        { key: 'invoiceNo', label: '发票号码' },
        { key: 'email', label: '接收邮箱' },
        { key: 'status', label: '开票状态', type: 'select', options: statusOptions },
        { key: 'invoiceFile', label: '发票文件', type: 'upload-file', accept: '.pdf,.jpg,.jpeg,.png' }
      ]
    }
  }
}
</script>
